module.exports = __webpack_public_path__ + "static/media/alcohol-addictions-test-yourself-large@3x.1bf2767b.png";